import useGtagPageView from "src/hooks/useGtagPageView";

/** Super dumb provider that sends page changes to Google Analytics */
const GtagProvider = () => {
    useGtagPageView();
    return null;
};

export default GtagProvider;
